module.exports = __webpack_public_path__ + "static/media/1-what-is-a-colonoscopy-general-02-1-x@3x.af31db63.png";